export default "__VITE_ASSET__Ct9T8639__"